import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Firm from "@/pages/Firm";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import People from "@/pages/People";
import Insights from "@/pages/Insights";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminReset from "@/pages/admin/AdminReset";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { CONTACT } from "@/data/site";

const JsonLd = () => {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "AccountingService",
      name: "Arun Gupta & Co. Chartered Accountants",
      description:
        "Chartered Accountancy practice established in Kanpur in 1990, providing audit, taxation, accounting, financial reporting and business advisory services.",
      foundingDate: "1990",
      url: "https://arunguptaandco.com",
      email: CONTACT.email,
      telephone: CONTACT.phones[0],
      image: "https://arunguptaandco.com/brand/logo.png",
      sameAs: [CONTACT.linkedin],
      areaServed: "Kanpur, Uttar Pradesh, India",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Office No. 20, Upper Floor, Roland Complex, 37/17, The Mall",
        addressLocality: "Kanpur",
        postalCode: "208001",
        addressRegion: "Uttar Pradesh",
        addressCountry: "IN",
      },
      knowsAbout: [
        "Audit & Assurance",
        "Taxation",
        "GST",
        "Income Tax",
        "Accounting & Financial Reporting",
        "Business Advisory",
      ],
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    script.id = "ld-json-firm";
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById("ld-json-firm");
      if (el) el.remove();
    };
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <JsonLd />
        <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }} />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset" element={<AdminReset />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/the-firm" element={<Firm />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/industries" element={<Industries />} />
                  <Route path="/our-people" element={<People />} />
                  <Route path="/insights" element={<Insights />} />
                  <Route path="/careers" element={<Careers />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
